import { useMediaQuery, useTheme } from '@mui/material'
import { useMobileNav } from '@hooks/useMobileNav'

/** Bottom nav when mobile-nav flag is on and viewport is below `md`. */
export function useShowBottomNav(): boolean {
  const mobileNav = useMobileNav()
  const theme = useTheme()
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
  return mobileNav && !isMdUp
}
